var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 38,
    height: 38,
    rx: 6,
    fill: "#FF4343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4081 13.9111C13.7336 13.5856 14.2612 13.5856 14.5867 13.9111L18.9974 18.3218L23.4081 13.9111C23.7336 13.5856 24.2612 13.5856 24.5867 13.9111C24.9121 14.2365 24.9121 14.7641 24.5867 15.0896L20.1759 19.5003L24.5867 23.9111C24.9121 24.2365 24.9121 24.7641 24.5867 25.0896C24.2612 25.415 23.7336 25.415 23.4081 25.0896L18.9974 20.6788L14.5867 25.0896C14.2612 25.415 13.7336 25.415 13.4081 25.0896C13.0827 24.7641 13.0827 24.2365 13.4081 23.9111L17.8189 19.5003L13.4081 15.0896C13.0827 14.7641 13.0827 14.2365 13.4081 13.9111Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.fab650910c7620a9e119614ee78f4f32.svg";
export { ForwardRef as ReactComponent };